import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  AcceptedIcon,
  AssignedIcon,
  IncomingIcon,
  RejectedIcon,
} from "../assets/svgs/Icons";
import IncomingApplications from "./ContractorDashboard/IncomingApplications";
import AssignedApplications from "./ContractorDashboard/AssignedApplications";
import AcceptedApplications from "./ContractorDashboard/AcceptedApplications";
import RejectedApplications from "./ContractorDashboard/RejectedApplications";
import { useDispatch, useSelector } from "react-redux";
import { getCountForAdmins } from "./ContractorDashboard/ContractorSlice";
import isAllowed from "../routing/isAllowed";
import { useLocation, useNavigate } from "react-router-dom";

function Contractor() {
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();
  const { counts } = useSelector((state) => state.contractor);
  const [isActive, setIsActive] = useState(0);

  const navigate = useNavigate();

  const getCountsForContractor = async () => {
    try {
      setStatus("pending");
      const result = dispatch(getCountForAdmins());
      setStatus("success");
    } catch (error) {
      setStatus("failed");
      console.error(error);
    }
  };

  useEffect(() => {
    getCountsForContractor();
  }, []);

  const STEP_PAGES = [
    {
      id: 0,
      component: () => <IncomingApplications />,
    },
    {
      id: 1,
      component: () => <AssignedApplications />,
    },
    {
      id: 2,
      component: () => <AcceptedApplications />,
    },
    {
      id: 3,
      component: () => <RejectedApplications />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    setIsActive(tabIndex);
    localStorage.setItem("activeTab", tabIndex);
  };
  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTab") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));
  }, []);

  return (
    <Box>
      <Box bg="#EDF3F8" marginTop="2rem">
        <Grid
          width={"100%"}
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            xl: "repeat(4, 1fr)",
          }}
          my={"1rem"}
          gap="1rem"
          height={"100%"}
        >
          <GridItem>
            <Box
              bg={isActive === 0 ? "#fff" : "#B1DFFF"}
              color="#141D43
                          "
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              d={"flex"}
              boxShadow={
                isActive === 0
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(0);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="20" height="20" />
                </GridItem>

                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["INCOMING"] || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Incoming Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>

          <GridItem>
            <Box
              bg={isActive === 1 ? "#fff" : "#B8C9EA"}
              color="#141D43
                          "
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              boxShadow={
                isActive === 1
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              textAlign={"center"}
              onClick={() => {
                handleTabClick(1);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AssignedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["ASSIGNED"] || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Assigned Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 2 ? "#fff" : "#52BBFF"}
              color="#141D43"
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 2
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(2);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AcceptedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["APPROVE"] || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Accepted Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 3 ? "#fff" : "#FE96A6"}
              color="#141D43
                          "
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 3
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(3);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <RejectedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {counts?.["REJECT"] || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Rejected Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      {STEP_PAGES[page]?.component()}
      {/* child */}
    </Box>
  );
}

export default isAllowed(Contractor);
